import {NovaPessoa} from "./nova-pessoa";

export class AlteraPessoa extends NovaPessoa{
  id: number;
  ativo: boolean;
  dataCadastro: Date;
}
